import Common from '../common'
var Js = Common('product')
export default {
	name: 'product',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: 'product_no',
					label: '商品NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 100
				},
				{
					key: 'title',
					label: '商品名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入商品名称',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.title = val;
							} else {
								delete self.searchItem.title;
							};

						},
					},
				},
				{
					key: 'price',
					label: '展示价格',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					width:120
				},
				// {
				// 	key: 'stock',
				// 	label: '库存',
				// 	application: ['编辑', '添加'],
				// 	componentName: 'sls-input',
				// 	listType: 'normal',
				// 	width:120
				// },
				{
					key: 'total_sale_count',
					label: '销量',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width:120
				},
				{
					key: 'category_id',
					label: '商品类别',
					application: ['编辑', '添加'],
					formatter: function(val, tests) {
						return val.label[val.category_id]['title'];
					},
					componentName: 'sls-cascader',
					optionsName: 'labelOptions',
					listType: 'normal',
					limit: 10,
					defaultProps: {
						children: 'children',
						label: 'title',
						value: 'id',
					},
					width:150,
					placeholder: '请选择菜单',
					header_search: {
						componentName: 'sls-cascader',
						optionsName: 'labelOptions',
						placeholder: '请选择菜单',
						changeFunc: function(val, self) {
							var arr = self.$$getChildNames(self.optionData.labelOptions, 'id', 'children', val,
								[]);
							if (val) {
								if (arr.length > 0) {
									self.searchItem.category_id = ['in', arr];
								} else {
									self.searchItem.category_id = val;
								}
							} else {
								delete self.searchItem.category_id;
							};
						},
					}
				},
				{
					key: "tj_type",
					label: '推荐',
					application: ['编辑', '添加'],
					componentName: 'sls-select',
					optionsName: 'typeOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					listType: 'normal',
					formatter: function(val) {
						if (val.tj_type == 1) {
							return '是';
						} else {
							return '否';
						};
					},
					header_search: {
						componentName: 'sls-select',
						optionsName: 'typeOptions',
						placeholder: '请选择是否首页推荐',
						changeFunc: function(val, self) {
							if (val || val === 0) {
								self.searchItem.tj_type = val;
							} else {
								delete self.searchItem.tj_type;
							};
						},
					},
					width:120
				},
				{
					key: 'listorder',
					label: '排序',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					width:120
				},
				{
					key: 'content',
					label: '内容',
					application: ['编辑', '添加'],
					componentName: 'tinymce-editor',
					listType: '',
					dialogStyle: 'width:90%',
				},
				{
					key: 'mainImg',
					label: '主图',
					customSlot: 'mainImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%',
					width: 100
				},
				{
					key: 'bannerImg',
					label: '轮播图',
					customSlot: 'bannerImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: '',
					limit: 10,
					dialogStyle: 'width:90%',
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 160,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 170
				},
			],
			// 按钮配置
			btn_info: [{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							if (self.submitData.category_id == 0) {
								return false;
							};
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_productAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								content: '',
								price: '',
								mainImg: [],
								bannerImg: [],
								img_array: []
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 1;
							if (self.submitData.category_id == 0) {
								return false;
							};
							var postData = {
								data: self.submitData

							};
							postData.saveAfter = [{
								tableName: 'ProductDate',
								FuncName: 'add',
								data: {
									res: {
										product_no: 'product_no'
									},
									type: 1,
									is_template: 0,
									stock: 9999999
								}
							}]
							console.log(postData)

							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '商品规格'
					},
					funcType: 'func',
					func: {
						func: function(self) {
							
							self.$router.push({
								path: '/home/sku',
								name: 'SKU管理',
								params: {
									product_id: self.originFormData.id,
									path: '/home/product',
									delKeepAlive: true
								}
							});
						},
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'submit',
					position: 'list',
					text: function(data) {
						return '上架'
					},
					styleFunc: function(data) {
						if (data.on_shelf == -1) {
							return 'background-color: #029A15;border-color:#029A15'
						} else {
							return 'display:none'
						}
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: {
									on_shelf:1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'submit',
					position: 'list',
					text: function(data) {
						return '下架'
					},
					styleFunc: function(data) {
						if (data.on_shelf == 1) {
							return 'background-color: #eb8613;border-color:#eb8613'
						} else {
							return 'display:none'
						}
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: {
									on_shelf:-1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '选中上架'
					},
					styleFunc: function(data) {
						return 'background-color: #029A15;border-color:#029A15'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									on_shelf: 1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '选中下架'
					},
					styleFunc: function(data) {
						return 'background-color: #eb8613;border-color:#eb8613'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									on_shelf: -1
								}
							};
							return postData;
						}
					},
				},
			],

			searchItem: {
				type: 1,
				// thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
			},
			startSearchItem: {
				type: 1,
				// thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id
			},
			optionData: {
				labelOptions: [],
				skuOptions: [],
				typeOptions: [{
					text: '是',
					value: 1
				}, {
					text: '否',
					value: 0
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initLabelData();
		},

		async initLabelData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				type: 2,
				id:['not in',[20,21,9,18]]
			};
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.optionData.labelOptions = res.info.data;

		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {

				realStock: {
					tableName: 'ProductDate',
					middleKey: 'product_no',
					key: 'product_no',
					condition: '=',
					info: ['stock']
				}
			}

			var res = await self.$$api_productGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/product/product.js